module.exports = __webpack_public_path__ + "media/assets/images/logo_black-240776d0af37ffc36ddcb95d86f4fcff.png";